var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAverageCounter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    fillRule: "evenodd",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "1em",
    height: "0.5em",
    viewBox: "0 0 67.5 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document",
    fill: "none",
    stroke: "black",
    fontFamily: "Times New Roman",
    fontSize: 16,
    transform: "scale(1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Spread",
    transform: "translate(0 -36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -0.004,0 L -0.004,35.999 L 27.559,35.999 L 16.117,0 L -0.004,0 Z M 14.848,12.015 C 15.474,12.323 16.038,12.766 16.542,13.344 L 15.139,14.499 C 14.808,14.101 14.463,13.799 14.103,13.594 C 13.744,13.389 13.334,13.286 12.873,13.286 C 12.139,13.286 11.528,13.533 11.039,14.027 C 10.55,14.521 10.204,15.218 10.003,16.116 L 14.168,16.116 L 14.168,17.291 L 9.852,17.291 C 9.837,17.393 9.83,17.499 9.83,17.608 C 9.83,17.718 9.83,17.83 9.83,17.945 C 9.83,18.035 9.83,18.119 9.83,18.196 C 9.83,18.273 9.837,18.35 9.852,18.427 L 15.031,18.427 L 15.031,19.601 L 9.981,19.601 C 10.154,20.525 10.492,21.244 10.996,21.758 C 11.499,22.271 12.139,22.528 12.916,22.528 C 13.334,22.528 13.704,22.438 14.028,22.258 C 14.351,22.078 14.657,21.841 14.945,21.546 L 16.348,22.759 C 15.931,23.221 15.427,23.587 14.837,23.856 C 14.247,24.126 13.629,24.261 12.981,24.261 C 12.262,24.261 11.6,24.155 10.996,23.943 C 10.391,23.731 9.852,23.426 9.377,23.028 C 8.902,22.63 8.503,22.143 8.179,21.565 C 7.855,20.987 7.622,20.326 7.478,19.582 L 6.118,19.505 L 6.118,18.427 L 7.348,18.427 C 7.334,18.337 7.327,18.247 7.327,18.157 C 7.327,18.067 7.327,17.971 7.327,17.868 C 7.327,17.766 7.327,17.666 7.327,17.57 C 7.327,17.474 7.334,17.374 7.348,17.272 L 6.118,17.195 L 6.118,16.116 L 7.478,16.116 C 7.766,14.64 8.381,13.511 9.323,12.728 C 10.265,11.945 11.398,11.553 12.722,11.553 C 13.513,11.553 14.222,11.707 14.848,12.015 Z",
    stroke: "none",
    fill: "#56a862",
    fillRule: "evenodd",
    strokeWidth: 0.5,
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403193612775
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.278,-0.001 L 21.168,2.788 L 64.726,2.788 L 64.726,33.211 L 64.726,33.329 L 64.662,33.328 L 30.869,33.328 L 31.721,36 L 67.503,36 L 67.503,-0.001 L 20.278,-0.001 Z",
    fillRule: "evenodd",
    strokeWidth: 1.614,
    stroke: "none",
    fill: "#56a862",
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403193612775
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 31.334,29.097 C 31.334,30.314 32.141,31.127 33.349,31.127 C 34.357,31.127 35.364,30.314 35.364,29.097 C 35.364,27.884 34.357,27.074 33.349,27.074 C 32.141,27.074 31.334,27.884 31.334,29.097 Z",
    stroke: "none",
    fill: "#666666",
    strokeLinejoin: "round",
    strokeWidth: 1.313,
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403193612775
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28.912,18.205 L 28.912,21.644 C 28.912,23.467 30.322,25.087 32.34,25.087 L 34.357,25.087 C 36.174,25.087 37.784,23.467 37.784,21.644 L 37.784,18.205 L 28.912,18.205 Z",
    stroke: "none",
    fill: "#666666",
    strokeLinejoin: "round",
    strokeWidth: 1.313,
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403193612775
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.085,18.411 C 40.085,18.517 40.138,18.517 40.245,18.569 C 40.472,18.66 40.738,18.752 40.978,18.846 L 40.977,21.439 C 40.553,22.002 40.133,22.562 39.708,23.083 C 39.603,23.244 39.5,23.351 39.441,23.513 C 39.386,23.622 39.441,23.673 39.551,23.673 L 43.079,23.673 C 43.189,23.673 43.243,23.673 43.294,23.622 C 43.294,23.564 43.243,23.457 43.243,23.406 C 42.741,22.749 42.195,22.046 41.687,21.39 L 41.687,18.83 C 41.939,18.77 42.194,18.668 42.494,18.569 C 42.545,18.517 42.597,18.517 42.597,18.411 C 42.597,18.37 42.587,18.336 42.574,18.311 L 40.119,18.311 C 40.097,18.336 40.085,18.37 40.085,18.411 Z",
    stroke: "none",
    fill: "#666666",
    strokeLinejoin: "miter",
    strokeWidth: 0.055,
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403193612775
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 44.679,18.411 C 44.679,18.517 44.734,18.517 44.841,18.569 C 45.067,18.66 45.334,18.752 45.573,18.846 L 45.572,21.439 C 45.148,22.002 44.728,22.562 44.303,23.083 C 44.2,23.244 44.094,23.351 44.039,23.513 C 43.985,23.622 44.039,23.673 44.146,23.673 L 47.677,23.673 C 47.783,23.673 47.838,23.673 47.892,23.622 C 47.892,23.564 47.838,23.457 47.838,23.406 C 47.334,22.749 46.789,22.044 46.281,21.388 L 46.282,18.829 L 46.281,18.831 C 46.534,18.771 46.787,18.669 47.086,18.569 C 47.14,18.517 47.192,18.517 47.192,18.411 C 47.192,18.37 47.182,18.336 47.173,18.311 L 44.721,18.311 C 44.698,18.336 44.679,18.37 44.679,18.411 Z",
    stroke: "none",
    fill: "#666666",
    strokeLinejoin: "miter",
    strokeWidth: 0.055,
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403193612775
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 52.824,29.097 C 52.824,30.314 53.632,31.127 54.843,31.127 C 55.849,31.127 56.86,30.314 56.86,29.097 C 56.86,27.884 55.849,27.074 54.843,27.074 C 53.632,27.074 52.824,27.884 52.824,29.097 Z",
    stroke: "none",
    fill: "#666666",
    strokeLinejoin: "round",
    strokeWidth: 1.313,
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403193612775
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 52.846,4.211 L 51.903,13.374 L 50.736,13.374 L 50.736,14.541 C 50.713,14.535 50.689,14.533 50.665,14.533 L 28.513,14.533 C 28.347,14.533 28.211,14.671 28.211,14.836 L 28.211,16.375 C 28.211,16.54 28.347,16.679 28.513,16.679 L 50.665,16.679 C 50.689,16.679 50.713,16.676 50.736,16.67 L 50.736,21.644 C 50.736,23.467 52.15,25.087 54.165,25.087 L 56.182,25.087 C 57.995,25.087 59.608,23.467 59.608,21.644 L 59.608,16.679 L 63.721,16.679 C 63.888,16.679 64.022,16.54 64.022,16.375 L 64.022,14.836 C 64.022,14.671 63.888,14.533 63.721,14.533 L 59.608,14.533 L 59.608,13.374 L 58.412,13.374 L 57.686,4.211 L 55.817,4.211 L 55.26,12.871 L 54.846,4.211 L 52.846,4.211 Z",
    stroke: "none",
    fill: "#666666",
    strokeLinejoin: "miter",
    strokeWidth: 0.216,
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403193612775
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAverageCounter);
export default __webpack_public_path__ + "static/media/icon-average-counter.5baf119e5965c48372e8aee0c7499f80.svg";
export { ForwardRef as ReactComponent };